import * as React from "react";

export const FeaturesContext = React.createContext<MyFeatures>(null);
